import React from 'react';
import type { DocumentType } from '../../graphql/generated/gql';
import { gql } from '../../graphql/generated/gql';
import MagneticWallItemAvatar from '../MagneticWallItemAvatar';
import * as styles from './CommentThreadCompactAvatar.module.scss';

const USER_FRAGMENT = gql(`
  fragment CommentThreadCompactAvatar_user on UserFields {
    ...MagneticWallItemAvatar_user
  }
`);

interface CommentThreadCompactAvatarProps {
  user: DocumentType<typeof USER_FRAGMENT>;
}

const CommentThreadCompactAvatar = ({
  user,
}: CommentThreadCompactAvatarProps) => (
  <div className={styles.avatar}>
    <MagneticWallItemAvatar user={user} />
  </div>
);

export default CommentThreadCompactAvatar;
